import { BlazepayPaymentOptionModels } from '@getgreenline/payments'
import { LocalStorage } from './LocalStorage'

interface CachePaymentOptionsArgs {
  merchantId: string
  paymentOptions?: BlazepayPaymentOptionModels.IPaymentOptionEventOrRestData[]
}

interface PaymentOptionsWithCacheArgs {
  merchantId: string
}

export const cachePaymentOptions = ({ merchantId, paymentOptions }: CachePaymentOptionsArgs) => {
  if (paymentOptions) {
    LocalStorage.setPaymentOptionsCache(merchantId, paymentOptions)
  } else {
    LocalStorage.setPaymentOptionsCache(merchantId, [])
  }
}

export const getPaymentOptionsWithCache = ({ merchantId }: PaymentOptionsWithCacheArgs) => {
  const cachedPaymentOptions = LocalStorage.getPaymentOptionsCache(merchantId)
  return cachedPaymentOptions || []
}
